import { SizableText, XStack } from '@mythical/ui'
import useMutation from 'app/hooks/use-mutation'
import { blockMutation, blockResult } from 'app/mutations/member/block'
import { observer } from 'mobx-react-lite'

import { Button } from 'app/components/primitive/Button'
import { StyledDialog } from 'app/components/primitive/StyledDialog'

const query = blockMutation()

interface UnlockButtonProps {
  id: string
  modalOpen: boolean
  onBlock: () => void
  setModalOpen: (open: boolean) => void
}

export const BlockModal = observer<UnlockButtonProps>(
  ({ id, modalOpen, onBlock, setModalOpen }) => {
    const { loading, data, error, makeRequest } = useMutation(
      query,
      blockResult,
    )

    const handleBlock = async () => {
      const data = await makeRequest({ id })

      if (data?.success) {
        onBlock()
        setModalOpen(false)
      }
    }

    return (
      <StyledDialog
        open={modalOpen}
        onOpenChange={(open) => setModalOpen(open)}
        title="Block User"
        description="Are you sure you want to block this user?"
      >
        {(error || (data && !data.success)) && (
          <SizableText color="$fgError" ta="center">
            {error?.message || data?.reason || 'Unknown Error'}
          </SizableText>
        )}

        <XStack gap="$2" jc="center">
          <Button theme="secondary" onPress={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button theme="primary" onPress={handleBlock} loading={loading}>
            {!data?.success && 'Block'}
            {data && data.success && 'Blocked'}
          </Button>
        </XStack>
      </StyledDialog>
    )
  },
)
